// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Job",
  bookSlug: "job",
  chapter: 25,
  argument: "Baldad represents the justice of God, before whom no man can be justified.",
  verses: [
    { n: 1, text: "Then Baldad, the Suhite, answered, and said:" },
    { n: 2, text: "Power and terror are with him, who maketh peace in his high places." },
    { n: 3, text: "Is there any numbering of his soldiers; and upon whom shall not his light arise?" },
    { n: 4, text: "Can man be justified, compared with God, or he that is born of a woman appear clean?" },
    { n: 5, text: "Behold even the moon doth not shine, and the stars are not pure in his sight." },
    { n: 6, text: "How much less man that is rottenness, and the son of man who is a worm?" },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Answered. He directs his attack against Job's desiring to plead before God, and gives a wrong statement of his request, which he also attempts to refute, by urging the same inconclusive arguments as before. (Calmet) — Blind and obstinate disputers still repeat the same objections; (Worthington) as Protestants do against the Catholic doctrines, which have been so often and so ably defended.", attribution: "Haydock" }
    ] },
    { verse: 2, notes: [
      { text: "Places. Directing all the heavenly bodies with perfect harmony.", attribution: "Calmet" }
    ] },
    { verse: 3, notes: [
      { text: "Soldiers. The works of the whole creation, particularly the stars and angels.", attribution: "Menochius" }
    ] },
    { verse: 4, notes: [
      { text: "Clean. Job had used a similar expression, as well as Eliphaz, chap. iv. 17., and xiv. 4., and xv. 15. The holy man did not assert that he was free from sin, but only that God did not punish him (Calmet) so dreadfully (Haydock) on that account, and that he has just reasons for afflicting his servants, if it were only to manifest his own power and glory.", attribution: "Calmet" }
    ] },
    { verse: 5, notes: [
      { text: "Sight, compared with him. The most beautiful things in nature are nothing; and of course, the most just are all imperfection, when left to themselves.", attribution: "Calmet" }
    ] },
  ],
};

export default chapter;
